import { render, staticRenderFns } from "./dolgoviki.vue?vue&type=template&id=e6fde1a4&scoped=true&"
import script from "./dolgoviki.vue?vue&type=script&lang=js&"
export * from "./dolgoviki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6fde1a4",
  null
  
)

export default component.exports